import { Component, Input, OnInit } from '@angular/core';
import { transitionRecentActivity } from 'animations-lib';
import { currentUser } from 'auth-service-lib';
import { EntityControllerService } from 'entity-picker-lib';
import { IEntity, INamedEntity, IRecentActivityEntityProfile, ISharedServiceProviderService } from 'interfaces-lib';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { IdentityStorage } from 'storage-service-lib';
import { TerminologySentenceBuilder, TermPlaceholder } from 'terminology-lib';
import { runtimeEnvironment } from '../../../environments/environment';
import { ServiceProviderService } from '../../services/service.provider.service';
import { IRecentActivityProfileService } from './irecentactivityprofileservice';

@Component({
  selector: 'app-recent-activity',
  templateUrl: './recent-activity.component.html',
  styleUrls: ['./recent-activity.component.scss'],
  animations: [transitionRecentActivity],
  standalone: false,
})
export class RecentActivityComponent implements OnInit {
  renderMode = runtimeEnvironment.renderMode;

  @Input()
  sidebar = false;

  getStartedLabel;
  entityPicked: boolean;
  recentActivity: IRecentActivityEntityProfile[] = [];
  loggedIn = false;

  private recentActivityProfileService: IRecentActivityProfileService;
  private serviceProvider: ISharedServiceProviderService;

  constructor(
    private entityControllerService: EntityControllerService,
    private sharedServiceProviderServiceFactory: SharedServiceProviderServiceFactory,
    private identityStorage: IdentityStorage,
    serviceProviderService: ServiceProviderService
  ) {
    console.debug(`RecentActivityComponent created.`);
    this.recentActivityProfileService = serviceProviderService.getRecentActivityProfileService(runtimeEnvironment.origin.namespace);
    currentUser.currentUser$.subscribe((user) => (this.loggedIn = !!user));

    this.serviceProvider = this.sharedServiceProviderServiceFactory.getServiceProviderService(this.identityStorage.get()?.namespace);
    const terminologyService = this.serviceProvider.getTerminologyService();
    this.getStartedLabel = TerminologySentenceBuilder.format(
      `To get started, use the search box above to search for ` +
        `${TermPlaceholder.ANARTHROUS} ${TermPlaceholder.NAMESPACE} ${TermPlaceholder.RECORD_NAME}`,
      terminologyService
    );
  }

  ngOnInit(): void {
    console.debug(`RecentActivityComponent initialised. SideBar=${this.sidebar}, clientName=${runtimeEnvironment.client.name}`);
    const localStorageData: INamedEntity[] = JSON.parse(localStorage.getItem(runtimeEnvironment.client.name)) || [];
    localStorageData.forEach((entity) => {
      this.recentActivity.push(entity);
    });
    this.recentActivityProfileService.recentActivityEntityProfileSelected$.subscribe((entity) => this.entitySelected(entity));
  }

  imageFailed(entity: IRecentActivityEntityProfile) {
    entity.profilePic = undefined;
    entity.profilePicBlurred = undefined;
  }

  navigateToEntity(entity: INamedEntity): void {
    // TODO: Need to clear header search bar after a search
    this.entityControllerService.entitySelected(entity);
  }

  private entitySelected(entity: IRecentActivityEntityProfile): void {
    if (!entity) {
      this.entityPicked = false;
      return;
    }

    this.entityPicked = true;
    const index = this.recentActivity.findIndex((ra) => RecentActivityComponent.isSameEntity(ra, entity));
    if (index !== -1) {
      this.recentActivity.splice(index, 1);
    }

    if (this.recentActivity.length === 5) {
      this.recentActivity.splice(-1, 1);
    }

    this.recentActivity.unshift(entity);

    localStorage.setItem(runtimeEnvironment.client.name, JSON.stringify(this.recentActivity));
  }

  private static isSameEntity(a: IEntity | undefined, b: IEntity | undefined): boolean {
    return a?.id === b?.id && a?.type === b?.type;
  }
}
